import PropTypes from 'prop-types'
import { useId } from 'react'
import { I18n } from 'react-redux-i18n'
import { SelectCustom } from '../../../common/selectCustom'
import EventEmitter, { SHOW_SELECT_CUSTOM } from '../../../helpers/EventEmitter'
import DropdownItem from './DropdownItem'
import classes from './classes.module.scss'

const SELECT_CUSTOM_WIDTH = 160
const DROPDOWN_WIDTH = 236

const SelectPortfolio = ({
  activeItem,
  chooseItem,
  data,
  style,
  handleClickOutside,
  inputValue,
  onChange,
}) => {
  const id = useId()

  const blankItem = {
    label: I18n.t('portfolio.finance.BLANK'),
    value: undefined,
  }

  const onClick = (e) => {
    e.stopPropagation()
    EventEmitter.dispatch(SHOW_SELECT_CUSTOM, { id })
  }

  return (
    <div style={{ width: SELECT_CUSTOM_WIDTH }}>
      <SelectCustom
        id={id}
        activeItem={activeItem}
        chooseItem={chooseItem}
        data={data.length ? [blankItem, ...data] : []}
        isI18n={true}
        className="ml1"
        style={{ ...style, height: 26, padding: 0 }}
        customWidthDropdown={DROPDOWN_WIDTH}
        handleClickOutside={handleClickOutside}
        renderActiveItem={() => {
          return (
            <input
              value={inputValue}
              onChange={(e) => onChange(e.target.value)}
              className={classes.inputCustom}
              placeholder={I18n.t('portfolio.finance.SELECT_PORTFOLIO')}
              onFocus={() => onChange('')}
              onClick={onClick}
            />
          )
        }}
        renderDropdownItem={(item, onClickItem) => (
          <DropdownItem
            item={item}
            onClickItem={onClickItem}
            activeItem={activeItem}
          />
        )}
      />
    </div>
  )
}

SelectPortfolio.propTypes = {
  activeItem: PropTypes.object.isRequired,
  chooseItem: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  style: PropTypes.object,
  handleClickOutside: PropTypes.func,
  inputValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default SelectPortfolio
